import { ALUMNI_API_URL, LOAN_API_URL } from "../utils/constants";
import axios from "axios";


/**
 * Fetches the loan details used to verify an alumni loan account.
 * The API returns the account details under `data`.
 */
export const getLoanDetails = async (loanAccountNumber) => {
  const accountNumber = loanAccountNumber.trim();
  const response = await axios.get(`${LOAN_API_URL}/${encodeURIComponent(accountNumber)}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });

  const loanDetails = response.data?.data;
  if (!loanDetails?.loanDate) {
    const error = new Error("This loan account does not exist.");
    error.code = "LOAN_NOT_FOUND";
    error.response = response;
    throw error;
  }

  return loanDetails;
};

/**
 * Submits alumni data with the file metadata returned by the file upload API.
 */
export const submitAlumni = async ({ data, educationProof } = {}) => {
  // Build URL - allow full absolute URLs from env during development
  const url = ALUMNI_API_URL.startsWith("http") ? ALUMNI_API_URL : `${ALUMNI_API_URL}`;

  const requestPayload = {
    ...(data || {}),
    ...(educationProof ? { educationProof } : {}),
  };

  const response = await axios.post(url, requestPayload, {
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  });

  if (!response.data?.success) {
    throw response;
  }

  return response.data;
};

export const getAlumniErrorMessage = (data) => {
  return `Alumni profile already exists for this loan account number.Please check the details and try again.`;
};

export const getLoanErrorMessage = (error) => {
  if (error?.code === "LOAN_NOT_FOUND" || error?.response?.status === 404) {
    return "This loan account does not exist.";
  }

  return "Unable to verify the loan account. Please try again.";
};
